package one.healthium.bland.di

import org.koin.dsl.module

internal actual fun composeAppPlatformModule() = module {
}